/**
 * 所有mutation类型
 */
// 用户信息
export const USERINFO = 'USERINFO';
// 用户状态
export const USERSTATUS = 'USERSTATUS';
// 用户的token
export const USERTOKEN = 'USERTOKEN';
// 提币币种列表
export const CURRENCYLIST = 'CURRENCYLIST';
// 购买会员记录
export const MEMBERORDERLIST = 'MEMBERORDERLIST';
// 用户中心信息
export const USERMEMBERCENTER = 'USERMEMBERCENTER';
// 优惠券列表
export const COUPONS = 'COUPONS';
// 用户绑卡信息
export const WALLETBANK = 'WALLETBANK';
// 资金流水筛选信息
export const FLOWFILTERING = 'FLOWFILTERING';
// 安全退出
export const LOGINOUT = 'LOGINOUT';
// 主题色
export const NOW_THEME_COLOR = 'NOW_THEME_COLOR';
// 涨跌色
export const NOW_UP_COLOR = 'NOW_UP_COLOR';
// 语言
export const NOW_LANG = 'NOW_LANG';
// 当前页面
export const ACTIVE_PAGE = 'ACTIVE_PAGE';
// 合约
export const ACTIVESYMBOL = 'ACTIVESYMBOL';
// websocket地址
export const QUOTE_WS_URL = 'QUOTE_WS_URL';
// 商品列表
export const PRODUCT_LIST = 'PRODUCT_LIST';

// 入金选择范围
export const FITLABELLIST = 'FITLABELLIST';
// 入金通道大类型
export const PAYTYPE = 'PAYTYPE';
// 出金通道大类型
export const WITHDRAWTYPE = 'WITHDRAWTYPE';
